<p>collector-chart works!</p>
